"use client";

import { SkeletonBlock, SkeletonLine, SkeletonPill, SkeletonStack, WidgetCard } from "@health/ui";

/**
 * Loading skeleton mirroring PricingBreakdown — header, two stacked plan
 * cards, a totals strip, and a full-width continue CTA.
 *
 * Lives in its own file so {@link WidgetLoadingRegistry} can import it
 * without pulling in the lazy-loaded {@link PricingBreakdown} chunk.
 */
export function PricingBreakdownSkeleton() {
  return (
    <WidgetCard $padding="lg" className="w-full">
      <SkeletonStack>
        <SkeletonLine $size="title" $width="md" />
        <SkeletonLine $size="caption" $width="lg" />
        <div className="space-y-3 pt-1">
          {[0, 1].map((i) => (
            <SkeletonBlock key={i} $h="sm" $radius="md" />
          ))}
        </div>
        <SkeletonBlock $h="sm" $radius="md" />
        <SkeletonPill $size="lg" $width="xl" className="w-full" />
      </SkeletonStack>
    </WidgetCard>
  );
}
